import React from 'react'
import Content from './Content';
import Feature from './Feature';
import Social from './Social';

const Main = () => {
  return (
    <div className='main'>
        <Content />
        <Feature />
        <Social />
    </div>
  )
}

export default Main